import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userSession } from "../../services/client-login-service";

const FullScreenGames = () => {
  const navigate = useNavigate();

  // Add loading state
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = (gamesThumbnail, gamesUrl) => {
    localStorage.setItem("gameThumbnail", gamesThumbnail);
    localStorage.setItem("gameUrl", gamesUrl);
    navigate("../game-component1");
  };

  const games = [
    { thumbnail: "Traffic.webp", url: "035.Sahara%20Invasion/" },
    { thumbnail: "Truck-Racer.webp", url: "100.Truck%20Racer/" },
    { thumbnail: "Stick-Soldier.webp", url: "104.Stick%20Panda/" },
    { thumbnail: "Quick_Dice.webp", url: "053.Quick%20Dice/" },
    { thumbnail: "Memory-Game.webp", url: "065.Memory%20Game/" },
    { thumbnail: "Halloween-Memory.webp", url: "015.Halloween%20Memory/" },
    {
      thumbnail: "Halloween_Bubble_Shooter.webp",
      url: "024.Halloween%20Bubble%20Shooter/",
    },
    {
      thumbnail: "Frog-Super-Bubbles.webp",
      url: "110.Frog%20Super%20Bubbles/",
    },
    { thumbnail: "Christmas_Match_3.webp", url: "017.Christmas%20Match%203/" },
    { thumbnail: "Candy-Match-3.webp", url: "050.Candy%20Match%203/" },
    { thumbnail: "Classic-Match-3.webp", url: "073.Classic%20Match%203/" },
    { thumbnail: "Halloween-Match-3.webp", url: "087.Halloween%20Match%203/" },
    { thumbnail: "Touch-Ball.webp", url: "052.Touch%20Ball/" },
    {
      thumbnail: "Funny-Faces-Match-3.webp",
      url: "097.Funny%20Faces%20Match%203/",
    },
    {
      thumbnail: "Funny-Animals-Match-3.webp",
      url: "072.Funny%20Animals%20Match%203/",
    },
    {
      thumbnail: "Happy-Halloween-Match-3.webp",
      url: "009.Happy%20Halloween/",
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const session = {
  //         userSessionId: localStorage.getItem("UserSessionId"),
  //         sessionType: "Games",
  //         userId: localStorage.getItem("jwt_j"),
  //       };

  //       await userSession(session);
  //       // Additional data loading logic if needed...

  //       setIsLoading(false);
  //     } catch (error) {
  //       console.error("Error loading data:", error);
  //       // Handle error loading data...
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  return (
    <div style={{ visibility: isLoading ? "hidden" : "visible" }}>
      <div>
        <section className="game-play-section game-play-section2">
          <h1
            className="SelectedForYou"
            style={{
              fontSize: "1.5em",
              marginTop: "-20px",
              position: "absolute",
              top: "25px",
              left: "0",
              right: "0",
              color: "#fff",

              fontSize: "25px",
            }}
          >
            SELECTED FOR YOU
          </h1>
          <div
            className=" games-container"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              marginTop: "-35px",
            }}
          >
            {games.map((game, index) => (
              <div
                key={index}
                className="single-play1 action-games"
                style={{ marginBottom: "20px" }}
              >
                <div
                  className="image"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "14px",
                  }}
                >
                  <img
                    src={`assets/Icons/${game.thumbnail}`}
                    alt="action-game-images"
                    className="zoomable-image"
                    loading="lazy"
                  />
                </div>
                <div
                  className=" play-like-action"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <a
                    className="like-button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "18px",
                      width: "100px",
                      letterSpacing: "1px",
                    }}
                    onClick={() =>
                      handleClick(`assets/Icons/${game.thumbnail}`, game.url)
                    }
                  >
                    Play
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default FullScreenGames;
